if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);

        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');

        const spinner = opener.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            if (!this.productElement) return;

            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();

            this.bindVariantSync();

            if (typeof window.initQuickViewButtonPrice === 'function') {
              window.initQuickViewButtonPrice(this.modalContent);
            }

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');

            if (spinner) spinner.classList.add('hidden');

            // Si Swiper no existe en tu tema, esto fallará: por eso lo protejo.
            if (window.Swiper) {
              // OJO: si abres/cierra muchas veces, esto crea instancias nuevas.
              // Si quieres, luego lo mejoramos guardando y destruyendo la instancia.
              new Swiper('.js-media-list', {
                slidesPerView: 1,
                navigation: {
                  nextEl: '.swiper-btn--next',
                  prevEl: '.swiper-btn--prev',
                },
              });
            }
          });
      }

      bindVariantSync() {
        // Evita duplicar listeners cada vez que se abre el modal
        if (this.modalContent.dataset.qvSyncBound === '1') {
          this.syncVariantIdAllForms();
          return;
        }

        this.modalContent.dataset.qvSyncBound = '1';

        // Dispara sync cuando cambian selects/radios
        this.modalContent.addEventListener('change', () => {
          setTimeout(() => this.syncVariantIdAllForms(), 0);
        });

        // En algunos temas, los radios cambian por click (depende del markup)
        this.modalContent.addEventListener('click', () => {
          setTimeout(() => this.syncVariantIdAllForms(), 0);
        });

        this.syncVariantIdAllForms();
      }

      syncVariantIdAllForms() {
        const picker = this.modalContent.querySelector('variant-radios, variant-selects');
        if (!picker) return;

        const jsonEl = picker.querySelector('script[type="application/json"]');
        if (!jsonEl) return;

        let variants;
        try {
          variants = JSON.parse(jsonEl.textContent);
        } catch (e) {
          return;
        }

        const selected = [];

        picker.querySelectorAll('fieldset').forEach((fs) => {
          const checked = fs.querySelector('input[type="radio"]:checked');
          selected.push(checked ? checked.value : null);
        });

        picker.querySelectorAll('select').forEach((sel) => selected.push(sel.value));

        if (selected.some((v) => !v)) return;

        const match = variants.find((v) =>
          selected.every(
            (val, i) => String(v[`option${i + 1}`]).trim() === String(val).trim()
          )
        );

        if (!match?.id) return;

        this.modalContent
          .querySelectorAll('form[action*="/cart/add"] input[name="id"]')
          .forEach((inp) => {
            inp.value = String(match.id);
          });

        // Si tu función de precio usa el variantId (input[name="id"]), aquí ya queda actualizado
        if (typeof window.initQuickViewButtonPrice === 'function') {
          window.initQuickViewButtonPrice(this.modalContent);
        }
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinyecta scripts para que se ejecuten (innerHTML no ejecuta scripts por defecto)
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const gift = this.productElement.querySelector('.customer');
        if (gift) gift.remove();
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;

        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
          sectionId,
          `quickadd-${sectionId}`
        );

        this.productElement
          .querySelectorAll('variant-selects, variant-radios')
          .forEach((variantSelect) => {
            variantSelect.dataset.originalSection = sectionId;
          });
      }

      preventVariantURLSwitching() {
        const el = this.modalContent.querySelector('variant-radios,variant-selects');
        if (el) el.setAttribute('data-update-url', 'false');
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => {
          li.setAttribute('role', 'presentation');
        });
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        if (!product) return;

        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
